import "../pages.scss"
import { EmpleadosState } from '../../context/empleados/EmpleadosState';
import Datatable from "./empleadosTable/Datatable"

const EmpleadosPage = () => {
  return (
    <>
      <EmpleadosState>
        <Datatable />
      </EmpleadosState>
    </>
  )
}

export default EmpleadosPage